import {
  COLUMN_BASED_CONFIG,
  ROW_BASED_CONFIG,
  WATCH_CONFIG_TABLE_NAMES,
  WATCH_ROW_BASED_CONFIG_TABLES,
  type WatchConfigTableName,
  type WatchConfigTableType,
  sortWatchConfigTableNames,
} from './watchSocket.constants';

export { sortWatchConfigTableNames };

export const isWatchConfigTable = (value: unknown): value is WatchConfigTableName =>
  typeof value === 'string' && (WATCH_CONFIG_TABLE_NAMES as readonly string[]).includes(value);

export const getConfigTableType = (table: WatchConfigTableName): WatchConfigTableType =>
  (WATCH_ROW_BASED_CONFIG_TABLES as readonly string[]).includes(table) ? ROW_BASED_CONFIG : COLUMN_BASED_CONFIG;

/** Mirrors `ConfigTableName.table_id()` in the HMI local backend. */
export const getConfigTableIdColumn = (table: WatchConfigTableName): string =>
  getConfigTableType(table) === ROW_BASED_CONFIG ? 'pk' : `${table.charAt(0).toLowerCase()}${table.slice(1)}Id`;
